import { render, staticRenderFns } from "./reject-reason.dialog.vue?vue&type=template&id=65d1db8f&scoped=true"
import script from "./reject-reason.dialog.vue?vue&type=script&lang=js"
export * from "./reject-reason.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d1db8f",
  null
  
)

export default component.exports